var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M15.821 25.84q-4.25 0-7.199-2.947t-2.948-7.16 2.947-7.16 7.167-2.948q4.218 0 7.165 2.948t2.947 7.16q0 1.763-.6 3.41a9.7 9.7 0 0 1-1.688 2.946l9.961 9.916q.301.289.31.746.008.456-.31.768a1.05 1.05 0 0 1-.765.312q-.449 0-.754-.317L22.12 23.58a9 9 0 0 1-2.892 1.67 10 10 0 0 1-3.407.59m-.017-2.093q3.351 0 5.676-2.332t2.326-5.682-2.326-5.682q-2.325-2.332-5.676-2.332-3.364 0-5.7 2.332t-2.336 5.682 2.336 5.682 5.7 2.332"
  }))));
};
export default SvgSearch;